import styled from "styled-components";

export const StyledLoading = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 50px;
    animation: spin 2s infinite linear;
  }
`;
